export default __webpack_public_path__ + "static/media/normalBlack.ec34f07d.png";